import React from "react";
import { Link } from "react-router-dom";
import DetailItem from "./DetailItem"; 
import style from "./ClientCars.module.scss";
import { FaCarAlt } from "react-icons/fa";
import { CarSearchSelect } from "../../../../components/Search/CarsSearchSelect";
import { useTranslation } from "react-i18next";

const ClientCars = ({ cars, isEditing }) => {
  const { t } = useTranslation();
  const carList = Array.isArray(cars) ? cars : cars ? [cars] : [];

  return (
    <>
      {carList.length > 0 ? (
        <div className={style.grid}>
          {carList.map((car) => (
            <div key={car.id} className={style.carCard}>
              <span className={style.icon}>
                <FaCarAlt />
              </span>    

              <DetailItem label={t("clientCars.carLabel")} value={`${car.manufacturer || ""} ${car.model || ""}`} />
              
              <Link to={`/cars/${car.id}`} className={style.plateLink}>
                <div className={style.plate}>
                  {car.reg_number || t("clientCars.noPlate")}
                </div>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <p className={style.noCars}>{t("clientCars.noCars")}</p>
      )}
    </>
  );
};

export default ClientCars;
